import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <Container>
        <Row className="g-4 text-center-mbl">
          <Col lg={4} md={6}>
            <div className="footer-brand">
              <div className="footer-logo">
                {/* <img src='' alt="logo"/> */}
                <h2 className='text-white'><b>OM SHAKTI <br/>GOOD SERVICES</b></h2>
              </div>
              <p className="footer-description">
                Your trusted partner for professional cleaning, renovation, and 
                manpower services. We deliver excellence in every project.
              </p>
            </div>
          </Col>
          <Col lg={2} md={6} xs={6}>
            <div className="footer-links">
              <h5>Quick Links</h5>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/services">Services</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
                <li>
                  <Link to="/gallery">Gallery</Link>
                </li>
              </ul>
            </div>
          </Col>
          <Col lg={3} md={6} xs={6}>
            <div className="footer-services">
              <h5>Our Services</h5>
              <ul>
                <li>Marble Polishing</li>
                <li>Granite Polishing</li>
                <li>Floor Cleaning</li>
                <li>Facade Glass Cleaning</li>
                <li>Wall Painting</li>
                <li>Renovation</li>
                <Link to="/services" className='text-white'><b>More Service</b></Link>
              </ul>
            </div>
          </Col>
          <Col lg={3} md={6}>
            <div className="footer-contact">
              <h5>Contact Info</h5>
              <p className='mb-0'>
                <strong>Phone:</strong><br />
                +91 9560424647
              </p>
              <p>
                +91 7838701636
              </p>
              <p>
                <strong>Email:</strong><br />
                omshaktigoodservices@gmail.com
              </p>
              <div className="social-links">
                <a href="#" aria-label="Facebook" className="social-icon">
                  <FaFacebook />
                </a>
                {/* <a href="#" aria-label="Twitter" className="social-icon">
                  <FaTwitter />
                </a> */}
                <a href="#" aria-label="Instagram" className="social-icon">
                  <FaInstagram />
                </a>
                {/* <a href="#" aria-label="LinkedIn" className="social-icon">
                  <FaLinkedin />
                </a> */}
                <a href="https://wa.me/919560424647" target='_blank' aria-label="WhatsApp" className="social-icon">
                  <FaWhatsapp />
                </a>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="footer-bottom">
              <p>
                &copy; {currentYear} OM SHAKTI GOOD SERVICES. All rights reserved. Created with ♥ by <a href='https://slptechnologie.com/' target='_blank' className='text-white'><b>SLP Technologie</b></a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;

